import MaterialTable from "@material-table/core";

export const SelectedOrderTable = (props) => {

  const { selectedMachines} = props;

  const columns = [
    {
        title: "OrderPath Id",
        field: "orderPathId",
        hidden: true,
        headerStyle: {
            fontSize: "12px",
        },
    },
    {
        title: "Comar",
        field: "comar",
        sorting: false,
        headerStyle: {
            fontSize: "12px",
        },
    },
    {
        title: "Order Number",
        field: "orderNumber",
        sorting: true,
        hidden: true,
        headerStyle: {
            fontSize: "12px",
        },
    },
    {
        title: "Order Number",
        field: "orderNumber",
        sorting: true,
        hidden: true,
        headerStyle: {
            fontSize: "12px",
        },
    },
    {
        title: "Order Year",
        field: "orderYear",
        sorting: true,
        hidden: true,
        headerStyle: {
            fontSize: "12px",
        },
    },
    {
        title: "From Location",
        field: "fromLocation",
        sorting: true,
        headerStyle: {
            fontSize: "12px",
        },
    },
    {
        title: "To Location",
        field: "toLocation",
        sorting: true,
        headerStyle: {
            fontSize: "12px",
        },
    },
    {
        title: "Model",
        field: "product",
        sorting: true,
        headerStyle: {
            fontSize: "12px",
        },
    },
    {
        title: "Serial No",
        field: "serial",
        sorting: true,
        headerStyle: {
            fontSize: "12px",
        },
    },
    {
        title: "Providers",
        field: "providerList",
        sorting: true,
        headerStyle: {
            fontSize: "12px",
        },
    },
    {
        title: "Status",
        field: "status",
        sorting: true,
        cellStyle: {
            width: 15,
            maxWidth: 15,
            textAlign: "left",
        },
        headerStyle: {
            fontSize: "12px",
        },
    },
    {
        title: "ETA",
        field: "eta",
        sorting: true,
        headerStyle: {
            fontSize: "12px",
        },
    },
];

  return (
    <div className="mt-n2">
      <MaterialTable
        options={{
          rowStyle: {
            fontSize: 9,
          },
          draggable: false,
          selection: false,
          search: false,
          toolbar:false,
          showTitle: false,
          sorting: false,
          paging: false,
          headerStyle: {
            backgroundColor: "#367c2b",
            fontWeight: "200",
            color: "white",
            position: "sticky",
            top: 0,
            zIndex: 10,
            textAlign: 'center'
          },
        
          tableContainerStyle: {
            overflow: "auto",
          },
          filterCellStyle: {
            flex: 1
          },
        }}
        columns={columns}
        data={selectedMachines}
      />
      <br />

    </div>
  );
};
